module.exports = __webpack_public_path__ + "static/img/group_qr_code1.4420085.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/group_qr_code1.png
// module id = KI2e
// module chunks = 1